<template>
  <div class="main">
    <Header 
      :show="false"
      title="首页"
      left="" 
      right="" 
      :click-left="handleClickLeft" 
      :click-right="handleClickRight"
    />
    <div>
      <van-cell-group>
        <van-cell center>
          <template #title>
            <div style="display: flex; align-items: center;">
              <div style="width: .8vw; height: 2.2vh; background-color: #82848a; border-radius: .5vw; float: left;" />
              <span style="font-size: 3.8vw; padding: .5vw 0 0 1.6vw; color: #82848a;">运行记录</span>
            </div>
          </template>
        </van-cell>
      </van-cell-group>
      <div style="background-color: #FFFFFF; padding: 2vh 2vw 2vh 2vw; margin-bottom: 10vh;">
        <el-timeline style="padding: 0 2vw; text-align: left;">
          <div 
            v-if="timeOrderList.length <= 0"
            style="text-align: center; color: #909399;"
          >无记录</div>
          <el-timeline-item 
            v-else
            v-for="activity in timeOrderList"
            :key="activity.id"
            :timestamp="activity.time" 
            placement="top"
          >
          <!-- :color="activity.color" -->
            <el-card>
              <van-cell center style="padding: 0 !important; border: 0; line-height: 3vh;">
                <template #title>
                  <h4 :style="{ 'color': activity.color }">{{ activity.title }}</h4>
                  <!-- <h4 v-if="activity.status === 0" style="color: #67C23A">{{ activity.title }}</h4>
                  <h4 v-else-if="activity.status === 1" style="color: #E6A23C; ">{{ activity.title }}</h4>
                  <h4 v-else-if="activity.status === 2" style="color: #F56C6C">{{ activity.title }}</h4>
                  <h4 v-else style="color: #909399">{{ activity.title }}</h4> -->
                </template>
                <template #right-icon>
                  <span style="color: cornflowerblue; font-size: 4vw;"></span>
                </template>
              </van-cell>
              <p>{{ activity.content }}</p>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>
    <Footer value="dashboard" />
  </div>
</template>

<script>
  import { Dialog } from 'vant';
  import { parseTime } from '@/utils'
  import checkPermission from '@/utils/permission'
  import Header from '@/views/components/header/index.vue'
  import Footer from '@/views/components/footer/index.vue'
  import { showPhoneAlarm } from '@/global/function.js'
  import { visitor } from "@/views/dashboard/config.json"
  import { getGateList, getEquipmentList, getManOrderList, getManAccessList, getTruckOrderList, getTruckAccessList, getWeighBridgeList, getMaterialCheckList } from '@/api/dashboard.js'

  export default {
    name: "Dashboard",
    components: {
      Header,
      Footer
    },
    inject: ['reload'],
    data() {
      const EDate = parseTime(new Date(), '{y}/{m}/{d}')
      const dayTimeStamp = (new Date(EDate)).getTime()
      const beforeTimeStamp = dayTimeStamp - 1*24*3600*1000
      const SDate = parseTime(beforeTimeStamp, '{y}/{m}/{d}')
      return {
        listQuery: {
          limit: 100,
          page: 1,
          start: beforeTimeStamp,
          end: dayTimeStamp
        },
        manOrderList: [],
        manAccessList: [],
        truckOrderList: [],
        truckAccessList: [],
        weighList: [],
        checkList: [],
        statusDef: ['成功', '告警', '故障', '正常', '结束'],
        colorDef: ['#67C23A', '#E6A23C', '#F56C6C', '#909399', '#909399'],
        orderList: [],
        guide: '欢迎您光临上犹万年青新型建材有限公司！',
        manNews: {
          timestamp: 0,
          content: '无记录'
        },
        aggregateNews: {
          timestamp: 0,
          content: '无记录'
        },
        tankNews: {
          timestamp: 0,
          content: '无记录'
        },
        concreteNews: {
          timestamp: 0,
          content: '无记录'
        }
      }
    },
    computed: {
      timeOrderList: function() {
        const data1 = this.manOrderList.concat(this.manAccessList)
        const data2 = this.truckOrderList.concat(this.truckAccessList)
        const data3 = this.weighList.concat(this.checkList)
        const data4 = data1.concat(data2)
        let data = data4.concat(data3)
        for (let i=0; i<data.length; i++) {
          data[i].id = i + 1
        }
        return this.sortByKey(data, 'stamp')
      }
    },
    watch: {
      timeOrderList: {
        handler(newVal, oldVal) {
          if ((newVal !== undefined) && (newVal.length > 0)) {
            const index = newVal[0].index
            this.guide = visitor[index]
          }
        },
        immediate: true
      }
    },
    beforeCreate() {
      
    },
    created() {
      this.handleGetManOrderList()
      this.handleGetManAccessList()
      this.handleGetTruckOrderList()
      this.handleGetTruckAccessList()
      this.handleGetWeighBridgeList()
      this.handleGetMaterialCheckList()
    },
    beforeMount() {
      
    },
    mounted() {
      
    },
    beforeUpdate() {
      
    },
    updated() {
      
    },
    beforeDestroy() {
      
    },
    destroyed() {
      
    },
    methods: {
      checkPermission,
      handleClickLeft() {
        // this.$router.go(-1)
        console.log('dashboard-left')
      },
      handleClickRight() {
        console.log('dashboard-right')
      },
      sortByKey(array, key) {
        return array.sort(function(a, b) {
          var x = a[key]
          var y = b[key]
          return ((x > y) ? -1 : (x>y) ? 1 : 0)
        })
      },
      handleGetManOrderList() {
        const data = {
          page: this.listQuery.page,
          limit: this.listQuery.limit,
          start: this.listQuery.start,
          end: this.listQuery.end
        }
        getManOrderList(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            const items = data.data.items
            this.manOrderList = []
            for (let i=0; i<items.length; i++) {
              let gateName = '办公区'
              if (items[i].gate === 1) {
                gateName = '办公区'
              } else if (items[i].gate === 2) {
                gateName = '生产区'
              } else if (items[i].gate === 3) {
                gateName = '办公区及生产区'
              }
              if (this.manNews.timestamp < items[i].createdTime) {
                this.manNews.timestamp = items[i].createdTime
                this.manNews.content = items[i].name + ' - ' + gateName + ' - 预约待审核'
              }
              this.manOrderList.push({
                index: 'order-apply',
                stamp: items[i].createdTime,
                time: parseTime(items[i].createdTime, '{y}-{m}-{d} {h}:{i}:{s}'),
                title: '访问预约 - 待审核',
                content: '起止日期：' + parseTime(items[i].startDate, '{y}/{m}/{d}') + ' - ' + parseTime(items[i].endDate, '{y}/{m}/{d}') + '，访问人员：' + items[i].name + '，访问区域：' + gateName,
                color: this.colorDef[1]
              })
              if ((items[i].audit === 1) || (items[i].audit === 2)) {
                if (this.manNews.timestamp < items[i].updatedTime) {
                  this.manNews.timestamp = items[i].updatedTime
                  this.manNews.content = items[i].name + ' - ' + gateName + ' - 预约已审核'
                }
                this.manOrderList.push({
                  index: items[i].audit === 1 ? 'order-agree' : 'order-refuse',
                  stamp: items[i].updatedTime,
                  time: parseTime(items[i].updatedTime, '{y}-{m}-{d} {h}:{i}:{s}'),
                  title: '访问预约 - ' + (items[i].audit === 1 ? '已通过' : '已拒绝'),
                  content: '起止日期：' + parseTime(items[i].startDate, '{y}/{m}/{d}') + ' - ' + parseTime(items[i].endDate, '{y}/{m}/{d}') + '，访问人员：' + items[i].name + '，访问区域：' + gateName,
                  color: items[i].audit === 1 ? this.colorDef[0] : this.colorDef[2]
                })
              }
            }
          }
        }).catch(function(error) {
          console.error(error)
        })
      },
      handleGetManAccessList() {
        const data = {
          page: this.listQuery.page,
          limit: this.listQuery.limit,
          start: this.listQuery.start,
          end: this.listQuery.end
        }
        getManAccessList(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            const items = data.data.items
            this.manAccessList = []
            for (let i=0; i<items.length; i++) {
              if (this.manNews.timestamp < items[i].accessTime) {
                this.manNews.timestamp = items[i].accessTime
                this.manNews.content = items[i].personName + ' - ' + items[i].gateName + ' - 访问中'
              }
              this.manAccessList.push({
                index: 'gate-access',
                stamp: items[i].accessTime,
                time: parseTime(items[i].accessTime, '{y}-{m}-{d} {h}:{i}:{s}'),
                title: '访问入场',
                content: '访问区域：' + items[i].gateName + '，访问人员：' + items[i].personName,
                color: this.colorDef[4]
              })
              if (items[i].exitTime !== '' && items[i].exitTime !== null) {
                if (this.manNews.timestamp < items[i].exitTime) {
                  this.manNews.timestamp = items[i].exitTime
                  this.manNews.content = items[i].personName + ' - ' + items[i].gateName + ' - 已离开'
                }
                this.manAccessList.push({
                  index: 'gate-exit',
                  stamp: items[i].exitTime,
                  time: parseTime(items[i].exitTime, '{y}-{m}-{d} {h}:{i}:{s}'),
                  title: '访问出场',
                  content: '访问区域：' + items[i].gateName + '，访问人员：' + items[i].personName,
                  color: this.colorDef[4]
                })
              }
            }
          }
        }).catch(function(error) {
          console.error(error)
        })
      },
      handleGetTruckOrderList() {
        const data = {
          page: this.listQuery.page,
          limit: this.listQuery.limit,
          start: this.listQuery.start,
          end: this.listQuery.end
        }
        getTruckOrderList(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            const items = data.data.items
            this.truckOrderList = []
            for (let i=0; i<items.length; i++) {
              if ((this.aggregateNews.timestamp < items[i].createdTime) && (items[i].truckType === '骨料货车')) {
                this.aggregateNews.timestamp = items[i].createdTime
                this.aggregateNews.content = items[i].plateNumber + ' - ' + items[i].materialName + ' - 预约待审核'
              }
              if ((this.tankNews.timestamp < items[i].createdTime) && (items[i].truckType === '罐装货车')) {
                this.tankNews.timestamp = items[i].createdTime
                this.tankNews.content = items[i].plateNumber + ' - ' + items[i].materialName + ' - 预约待审核'
              }
              if ((this.concreteNews.timestamp < items[i].createdTime) && (items[i].truckType === '其他货车')) {
                this.concreteNews.timestamp = items[i].createdTime
                this.concreteNews.content = items[i].plateNumber + ' - ' + items[i].materialName + ' - 预约待审核'
              }
              this.truckOrderList.push({
                index: 'order-apply',
                stamp: items[i].createdTime,
                time: parseTime(items[i].createdTime, '{y}-{m}-{d} {h}:{i}:{s}'),
                title: '访问预约 - 待审核',
                content: '起止日期：' + parseTime(items[i].startDate, '{y}/{m}/{d}') + ' - ' + parseTime(items[i].endDate, '{y}/{m}/{d}') + '，车牌号码：' + items[i].plateNumber + '(' + items[i].name +')' + '，供应商：' + items[i].supplierName + '，供应物料：' + items[i].materialName,
                color: this.colorDef[1]
              })
              if ((items[i].audit === 1) || (items[i].audit === 2)) {
                if ((this.aggregateNews.timestamp < items[i].updatedTime) && (items[i].truckType === '骨料货车')) {
                  this.aggregateNews.timestamp = items[i].updatedTime
                  this.aggregateNews.content = items[i].plateNumber + ' - ' + items[i].materialName + ' - 预约已审核'
                }
                if ((this.tankNews.timestamp < items[i].updatedTime) && (items[i].truckType === '罐装货车')) {
                  this.tankNews.timestamp = items[i].updatedTime
                  this.tankNews.content = items[i].plateNumber + ' - ' + items[i].materialName + ' - 预约已审核'
                }
                if ((this.concreteNews.timestamp < items[i].updatedTime) && (items[i].truckType === '其他货车')) {
                  this.concreteNews.timestamp = items[i].updatedTime
                  this.concreteNews.content = items[i].plateNumber + ' - ' + items[i].materialName + ' - 预约已审核'
                }
                this.truckOrderList.push({
                  index: items[i].audit === 1 ? 'order-agree' : 'order-refuse',
                  stamp: items[i].updatedTime,
                  time: parseTime(items[i].updatedTime, '{y}-{m}-{d} {h}:{i}:{s}'),
                  title: '访问预约 - ' + (items[i].audit === 1 ? '已通过' : '已拒绝'),
                  content: '起止日期：' + parseTime(items[i].startDate, '{y}/{m}/{d}') + ' - ' + parseTime(items[i].endDate, '{y}/{m}/{d}') + '，车牌号码：' + items[i].plateNumber + '(' + items[i].name +')' + '，供应商：' + items[i].supplierName + '，供应物料：' + items[i].materialName,
                  color: items[i].audit === 1 ? this.colorDef[0] : this.colorDef[2]
                })
              }
            }
          }
        }).catch(function(error) {
          console.error(error)
        })
      },
      handleGetTruckAccessList() {
        const data = {
          page: this.listQuery.page,
          limit: this.listQuery.limit,
          start: this.listQuery.start,
          end: this.listQuery.end
        }
        getTruckAccessList(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            const items = data.data.items
            this.truckAccessList = []
            for (let i=0; i<items.length; i++) {
              if ((this.aggregateNews.timestamp < items[i].accessTime) && (items[i].truckType === '骨料货车')) {
                this.aggregateNews.timestamp = items[i].accessTime
                this.aggregateNews.content = items[i].plateNumber + '(' + items[i].truckType + ') - ' + items[i].driver + ' - 访问中'
              }
              if ((this.tankNews.timestamp < items[i].accessTime) && (items[i].truckType === '罐装货车')) {
                this.tankNews.timestamp = items[i].accessTime
                this.tankNews.content = items[i].plateNumber + '(' + items[i].truckType + ') - ' + items[i].driver + ' - 访问中'
              }
              if ((this.concreteNews.timestamp < items[i].accessTime) && (items[i].truckType === '其他货车')) {
                this.concreteNews.timestamp = items[i].accessTime
                this.concreteNews.content = items[i].plateNumber + '(' + items[i].truckType + ') - ' + items[i].driver + ' - 访问中'
              }
              this.truckAccessList.push({
                index: 'barrier-access',
                stamp: items[i].accessTime,
                time: parseTime(items[i].accessTime, '{y}-{m}-{d} {h}:{i}:{s}'),
                title: '访问入场',
                content: '车牌号码：' + items[i].plateNumber + '(' + items[i].driver + ')',
                color: this.colorDef[4]
              })
              if (items[i].exitTime !== '' && items[i].exitTime !== null) {
                if ((this.aggregateNews.timestamp < items[i].exitTime) && (items[i].truckType === '骨料货车')) {
                  this.aggregateNews.timestamp = items[i].exitTime
                  this.aggregateNews.content = items[i].plateNumber + '(' + items[i].truckType + ') - ' + items[i].driver + ' - 已离开'
                }
                if ((this.tankNews.timestamp < items[i].exitTime) && (items[i].truckType === '罐装货车')) {
                  this.tankNews.timestamp = items[i].exitTime
                  this.tankNews.content = items[i].plateNumber + '(' + items[i].truckType + ') - ' + items[i].driver + ' - 已离开'
                }
                if ((this.concreteNews.timestamp < items[i].exitTime) && (items[i].truckType === '其他货车')) {
                  this.concreteNews.timestamp = items[i].exitTime
                  this.concreteNews.content = items[i].plateNumber + '(' + items[i].truckType + ') - ' + items[i].driver + ' - 已离开'
                }
                this.truckAccessList.push({
                  index: 'barrier-exit',
                  stamp: items[i].exitTime,
                  time: parseTime(items[i].exitTime, '{y}-{m}-{d} {h}:{i}:{s}'),
                  title: '访问出场',
                  content: '车牌号码：' + items[i].plateNumber + '(' + items[i].driver + ')',
                  color: this.colorDef[4]
                })
              }
            }
          }
        }).catch(function(error) {
          console.error(error)
        })
      },
      handleGetWeighBridgeList() {
        const data = {
          page: this.listQuery.page,
          limit: this.listQuery.limit,
          start: this.listQuery.start,
          end: this.listQuery.end
        }
        getWeighBridgeList(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            const items = data.data.items
            this.weighList = []
            for (let i=0; i<items.length; i++) {
              if ((this.aggregateNews.timestamp < items[i].grossTime) && (items[i].materialType === '骨料')) {
                this.aggregateNews.timestamp = items[i].grossTime
                this.aggregateNews.content = items[i].plateNumber + '(' + items[i].materialType + ') - ' + items[i].grossWeight + '吨 - 毛重完成'
              }
              if ((this.tankNews.timestamp < items[i].grossTime) && (items[i].materialType === '粉料')) {
                this.tankNews.timestamp = items[i].grossTime
                this.tankNews.content = items[i].plateNumber + '(' + items[i].materialType + ') - ' + items[i].grossWeight + '吨 - 毛重完成'
              }
              this.weighList.push({
                index: items[i].materialType === '骨料' ? 'gross-aggregate' : 'gross-tank',
                stamp: items[i].grossTime,
                time: parseTime(items[i].grossTime, '{y}-{m}-{d} {h}:{i}:{s}'),
                title: '地磅称重 - 毛重：' + items[i].grossWeight + '吨',
                content: '车牌号码：' + items[i].plateNumber + '(' + items[i].driver + ')，供应商：' + items[i].supplier,
                color: this.colorDef[4]
              })
              if (items[i].tareTime !== '' && items[i].tareTime !== null) {
                if ((this.aggregateNews.timestamp < items[i].grossTime) && (items[i].materialType === '骨料')) {
                  this.aggregateNews.timestamp = items[i].grossTime
                  this.aggregateNews.content = items[i].plateNumber + '(' + items[i].materialType + ') - ' + items[i].tareWeight + '吨 - 皮重完成'
                }
                if ((this.tankNews.timestamp < items[i].grossTime) && (items[i].materialType === '粉料')) {
                  this.tankNews.timestamp = items[i].grossTime
                  this.tankNews.content = items[i].plateNumber + '(' + items[i].materialType + ') - ' + items[i].tareWeight + '吨 - 皮重完成'
                }
                this.weighList.push({
                  index: items[i].materialType === '骨料' ? 'tare-aggregate' : 'tare-tank',
                  stamp: items[i].tareTime,
                  time: parseTime(items[i].tareTime, '{y}-{m}-{d} {h}:{i}:{s}'),
                  title: '地磅称重 - 皮重：' + items[i].tareWeight + '吨',
                  content: '车牌号码：' + items[i].plateNumber + '(' + items[i].driver + ')，供应商：' + items[i].supplier,
                  color: this.colorDef[4]
                })
              }
              if ((items[i].materialType === '骨料') && (items[i].qcTime !== '') && (items[i].qcTime !== null)) {
                if (items[i].status === 1) {
                  if ((this.aggregateNews.timestamp < items[i].grossTime)) {
                    this.aggregateNews.timestamp = items[i].grossTime
                    this.aggregateNews.content = items[i].plateNumber + '(' + items[i].materialName + ') - ' + items[i].waterPercent + '% - 检测合格'
                  }
                  this.weighList.push({
                    index: 'water-agree',
                    stamp: items[i].qcTime,
                    time: parseTime(items[i].qcTime, '{y}-{m}-{d} {h}:{i}:{s}'),
                    title: '地磅称重 - 检测合格',
                    content: '车牌号码：' + items[i].plateNumber + '(' + items[i].driver + ')，供应商：' + items[i].supplier,
                    color: this.colorDef[3]
                  })
                } else {
                  if ((this.aggregateNews.timestamp < items[i].grossTime)) {
                    this.aggregateNews.timestamp = items[i].grossTime
                    this.aggregateNews.content = items[i].plateNumber + '(' + items[i].materialName + ') - ' + items[i].waterPercent + '% - 检测不合格，退货'
                  }
                  this.weighList.push({
                    index: 'water-refuse',
                    stamp: items[i].qcTime,
                    time: parseTime(items[i].qcTime, '{y}-{m}-{d} {h}:{i}:{s}'),
                    title: '地磅称重 - 检测不合格，退货',
                    content: '车牌号码：' + items[i].plateNumber + '(' + items[i].driver + ')，供应商：' + items[i].supplier,
                    color: this.colorDef[2]
                  })
                }
              }
            }
          }
        }).catch(function(error) {
          console.error(error)
        })
      },
      handleGetMaterialCheckList() {
        const data = {
          page: this.listQuery.page,
          limit: this.listQuery.limit,
          start: this.listQuery.start,
          end: this.listQuery.end
        }
        getMaterialCheckList(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            const items = data.data.items
            this.checkList = []
            for (let i=0; i<items.length; i++) {
              if ((this.concreteNews.timestamp < items[i].createdTime)) {
                this.concreteNews.timestamp = items[i].createdTime
                this.concreteNews.content = items[i].plateNumber + ' -' + items[i].materialName + ' - 申请开罐'
              }
              this.checkList.push({
                index: 'open-apply',
                stamp: items[i].createdTime,
                time: parseTime(items[i].createdTime, '{y}-{m}-{d} {h}:{i}:{s}'),
                title: '开罐申请 - 待审核',
                content: '车牌号码：' + items[i].plateNumber + '，供应商：' + items[i].supplierName + '，供应物料：' + items[i].materialName + '，申请罐口：' + items[i].port,
                color: this.colorDef[4]
              })
              if (items[i].updatedTime !== '' && items[i].updatedTime !== null) {
                if ((this.concreteNews.timestamp < items[i].updatedTime)) {
                  this.concreteNews.timestamp = items[i].updatedTime
                  this.concreteNews.content = items[i].plateNumber + ' -' + items[i].materialName + ' - 灌料中'
                }
                this.checkList.push({
                  index: items[i].status === 2 ? 'open-agree' : 'open-refuse',
                  stamp: items[i].updatedTime,
                  time: parseTime(items[i].updatedTime, '{y}-{m}-{d} {h}:{i}:{s}'),
                  title: '开罐申请 - ' + (items[i].status === 1 ? '已通过' : '已拒绝'),
                  content: '车牌号码：' + items[i].plateNumber + '，供应商：' + items[i].supplierName + '，供应物料：' + items[i].materialName + '，申请罐口：' + items[i].port,
                  color: this.colorDef[4]
                })
              }
            }
          }
        }).catch(function(error) {
          console.error(error)
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  // 系统样式修改
  .van-cell {
    padding: 1.5vw 3vw;
  }
  ::v-deep h4 {
    font-size: 4vw;
    font-weight: 400;
    margin: 0;
  }
  ::v-deep p {
    display: block;
    margin-block-start: 0em;
    margin-block-end: 0em;
    margin-inline-start: 0rem;
    margin-inline-end: 0rem;
    font-size: 3.6vw;
    color: #999999;
    margin: 1vh 0 0;
  }
  ::v-deep .van-button__content {
    font-size: 4vw;
  }
  ::v-deep .van-dialog__confirm, .van-dialog__confirm:active {
    font-size: 4vw;
  }
  // 自定义样式
  .main {
    height: 100vh;
    font-size: 2vw;
    background-color: #FFFFFF;//#F8F8F8; 
    overflow-x: hidden;
    // overflow-y:hidden;
    overflow-y: auto;
    // display: flex; 
    // justify-content: center; 
    // align-items: center;
  }
</style>
